import { GlobalStore } from '@roc/feature-app-core';
import { IdentityCheckService } from '../services/identityCheckService';
import { IdentityCheckBaseStore } from './identityCheckBaseStore';

export class IdentityCheckStore extends IdentityCheckBaseStore {
  constructor(globalStore: GlobalStore) {
    super(globalStore);
    this.identityCheckService = new IdentityCheckService();
  }
}
